export default __webpack_public_path__ + "static/media/Physics01_11.30351701.png";